<template>
	<div class="kop-wrapper">
			<p class="kop">{{ content.tussenkop_1.tekst }}</p>
		</div>

		<div class="knd-locatie-knop">
			<button 
				class="knd-button locatie-delen" 
				@click="setUserLocation()"
			>
				Deel mijn locatie
			</button>
			<p v-if="notSharedYet" class="subtext">We slaan geen gegevens op</p>
			<p v-else class="subtext">{{ locatorText }}</p>
		</div>

		<div class="knd-button-wrapper">
				<p class="knd-button-next">Of zoek</p>
			<div class="knd-button-container knd-search-container">
				<div class='knd-input__container knd-input__container__white'>
					<input class='knd-search__input knd-input-gemeente' ref='inputgemeente' placeholder="selecteer een gemeente" />
						<img 
						class="knd-button-icon" 
						:src="require('@/assets/icons/arrow-down.svg')" 
						alt="" />
				</div>

				<div class='knd-input__container knd-input__container__buurt knd-input__container__white'>
					<input 
						placeholder="selecteer een buurt"
						class='knd-search__input knd-input-buurt dropdown-input' 
						ref='inputBuurt' 
					/>
						<img 
						class="knd-button-icon" 
						:src="require('@/assets/icons/arrow-down.svg')" 
						alt="" />
				</div>
			</div>
		</div>
</template>

<script>
	import * as Awesomplete from 'awesomplete';
	import 'awesomplete/awesomplete.css';

	import './index.scss';

export default {

	name: 'index',

	data () {
		return {
		locatorText: "we slaan geen gegevens op",
		content: this.$store.state.content,
		gemeenteAlle: this.$store.state.gemeenteAlle.gemeenten,
		buurtAlle: null,
		notSharedYet: true,
		first: true
		}
	},
	computed: {
		buurtSelected () {
			return this.$store.getters.buurtSelected;
		},

		gemeenteSelected () {
			return this.$store.getters.gemeenteSelected;
		},
	},  

	mounted: function() {
		this.renderAutoCompleteGemeente();
	},

	watch: {
		gemeenteSelected: { 
			handler(value) {
				this.buurtAlle = value.buurten;

				if(!this.buurtAlle) return;

				this.$refs.inputgemeente.placeholder = value.gemeente_naam;

				if(!this.first) {
					this.updateBuurten();
					return;
				}

				this.renderAutoCompleteBuurten();
				this.first = false;
			}, 
			deep: true
		},

		buurtSelected: {
			handler() {
				this.locatorText = this.buurtSelected.buurt_naam + ", " + this.gemeenteSelected.gemeente_naam;
				this.$refs.inputBuurt.placeholder = this.buurtSelected.buurt_naam;    

			},
			deep: true
		}
	},	
	methods: {
		sort(a, b) {
			return String(a.label).localeCompare(String(b.label));
		},

		renderAutoCompleteGemeente() {
			var input = this.$refs.inputgemeente;
			let data = this.$store.state.gemeentenAutocomplete;

			this.inputGemeenten = new Awesomplete(input, {
				list: data,
				minChars: 0,
				maxItems: data.length,
				sort: this.sort,
				replace: (suggestion) => {
					input.value = suggestion.label;

					let gemeente = data[+suggestion.value];						
					this.$refs.inputBuurt.value = '';
					
					this.$store.dispatch('loadGemeente', gemeente).then(d => {
						this.$refs.inputgemeente.placeholder = this.$refs.inputgemeente.value;
						this.$refs.inputgemeente.value = '';
						this.$refs.inputgemeente.blur();

						this.inputBuurten.placeholder = '';
						this.inputBuurten.evaluate();
					})
				}         
			});
			
			input.addEventListener("click", () => {
				if (this.inputGemeenten.ul.childNodes.length === 0) {
					this.inputGemeenten.minChars = 0;
					this.inputGemeenten.evaluate();
				}
				else if (this.inputBuurten?.ul?.hasAttribute('hidden')) {
					this.inputGemeenten.evaluate();
					this.inputGemeenten.open();
				}
				else {
					this.inputGemeenten.close();
				}
			});

		},

		renderAutoCompleteBuurten() {
			var input = this.$refs.inputBuurt;

			let data = this.buurtAlle.map((d, index) => {
				return {label: d.buurt_naam, value: index}
			});

			this.inputBuurten = new Awesomplete(input, {
				list: data,
				sort: this.sort,
				maxItems: data.length,
				minChars: 0,
				replace: (suggestion) => {
					input.value = '';
					input.blur();

					let buurt = this.buurtAlle[+suggestion.value];
					this.$store.dispatch('updateBuurtScenario', "stijging");
					this.$store.dispatch('updateBuurt', buurt);
				}     
			});
				
			input.addEventListener("click", () => {
				if (this.inputBuurten.ul.childNodes.length === 0) {
					this.inputBuurten.minChars = 0;
					this.inputBuurten.evaluate();
				}
				else if (this.inputBuurten?.ul?.hasAttribute('hidden')) {
					this.inputBuurten.evaluate();
					this.inputBuurten.open();
				}
				else {
					this.inputBuurten.close();
				}
			});
		},

		updateBuurten() {
			let data = this.buurtAlle.map((d, index) => {
				if(!d.buurt_naam) return;
				return {label: d.buurt_naam, value: index}
			});

			this.inputBuurten.list = data;
			this.inputBuurten.maxItems = data.length;

			// this.inputBuurten.evaluate();

			// if(this.$refs.inputBuurt.value) return;

			// this.inputBuurten.open();
		},

		setUserLocation() {
			this.notSharedYet = false;
			if (!navigator.geolocation) {
				this.locatorText = 'helaas konden we je locatie niet uitlezen'; //kon niet uitlezen browser
			} else {
				this.locatorText = 'locatie uitlezen...';

				navigator.geolocation.getCurrentPosition(position => {
					if(position && position.coords) {
						this.userLoc = [position.coords.longitude, position.coords.latitude];


						this.$store.dispatch('updateUserLoc', this.userLoc);
					}
				}, error => {
					console.error(error);
					let str;
					switch(error.code) {
						case error.PERMISSION_DENIED:
							str = "De instellingen op je apparaat blokkeren het uitlezen van je locatie. Pas je instellingen aan of gebruik de zoekfunctie."
						break;
							case error.POSITION_UNAVAILABLE:
							str = "Lokale informatie is niet beschikbaar."
						break;
							case error.TIMEOUT:
							str = "Er was een timeout waardoor de locatie niet kon worden opgehaald."
						break;
							case error.UNKNOWN_ERROR:
							str = "Onbekende error."
						break;
					}

					this.locatorText = str;
				});
			}
		}
	}
}
</script>

<style lang="css" scoped>
</style>